module.exports = function(product, options) {
  if(product.product_type === 'Gift Card') {
    return options.fn(this);
  }
  return options.inverse(this);
};